import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from "@tanstack/react-query";
import type { Sede, SedeInput, SedeListQuery, SedeUpdate } from "@nh/shared";
import { createSede, listSedes, updateSede, type SedePage } from "./sedes.api";

export const sedeKeys = {
  all: ["admin", "sedes"] as const,
  list: (query: SedeListQuery) => [...sedeKeys.all, "list", query] as const,
};

export function useSedes(query: SedeListQuery): UseQueryResult<SedePage, Error> {
  return useQuery({
    queryKey: sedeKeys.list(query),
    queryFn: () => listSedes(query),
    placeholderData: (previous) => previous,
  });
}

export function useCreateSede(): UseMutationResult<Sede, Error, SedeInput> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createSede,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: sedeKeys.all }),
  });
}

export function useUpdateSede(): UseMutationResult<
  Sede,
  Error,
  { id: string; update: SedeUpdate }
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, update }) => updateSede(id, update),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: sedeKeys.all }),
  });
}
